<template>
  <div class="overflow-hidden bg-gray p-2">
    <div class="grid grid-cols-12 gap-4 my-2">
      <div class="col-span-12">
        <iframe class="pdf" :src="url+'#toolbar=0'">
        </iframe>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const url = ref("https://mag.wcoomd.org/uploads/2018/05/blank.pdf");

const openFile = (newUrl: string) => {
  url.value = newUrl;
};

defineExpose({ openFile });
</script>
